import api from "../../services/api";

export const categoryService = {

    async getCategories(search = "") {

        const response = await api.get(
            "/blog/admin/categories/",
            {
                params: {
                    search,
                },
            }
        );

        return response.data;
    },

    async getCategory(id) {
        const { data } = await api.get(
            `/blog/admin/categories/${id}/`
        );

        return data;
    },

    async createCategory(payload) {
        await api.post(
            "/blog/admin/categories/",
            payload
        );
    },

    async updateCategory(id, payload) {
        await api.patch(
            `/blog/admin/categories/${id}/`,
            payload
        );
    },

    async deleteCategory(id) {
        await api.delete(
            `/blog/admin/categories/${id}/`
        );
    },

};